/* Little Bear's Helper: guided gift finder + message-taker for kingbearsquad.com. No outside services. */
(function () {
  'use strict';
  var root = document.getElementById('kbsh');
  var dataEl = document.getElementById('kbsh-data');
  if (!root || !dataEl) return;
  var DATA = { products: {} };
  try { DATA = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var P = DATA.products || {};

  var H = {
    story: 'their-story-one-question-a-week-their-answers-in-a-large-print-book',
    life: 'their-life-in-puzzles-a-personalized-large-print-word-search-book-made-to-order',
    custom: 'custom-word-search-puzzle-your-names-your-words-any-occasion',
    grandSet: 'the-grandparent-gift-set-their-life-in-puzzles-the-family-bundle-and-a-book-given-in-their-name',
    family: 'the-family-bundle-all-five-bearberry-hollow-printables',
    grandma: 'grandma-tell-me-your-story-printable-keepsake-journal-pdf',
    license: 'activity-director-print-license-large-print-puzzle-library-pdf',
    pack: 'care-home-pack-large-print-puzzle-books-for-activity-directors-and-hospice-teams',
    sub: 'bearberry-hollow-activity-subscription-for-care-homes',
    give: 'give-a-book-in-their-name-a-large-print-puzzle-book-for-a-care-home-or-hospice',
    kidsBook: 'your-childs-big-day-in-bearberry-hollow-a-personalized-storybook',
    calm: 'the-calm-corner-bundle-all-three-kids-printables',
    kidsSet: 'the-kids-gift-set-their-own-storybook-a-birthday-word-search-and-the-calm-corner-bundle',
    dog: 'good-dog-always-dog-memorial-bundle',
    cat: 'sunbeams-and-soft-places-cat-memorial-bundle',
    anyPet: 'always-our-good-one-complete-pet-memorial-bundle',
    petGift: 'the-thoughtful-gift-pet-memorial-gift-bundle',
    petKid: 'where-love-goes-a-kids-pet-goodbye-kit',
    memory: 'in-loving-memory-printable-family-keepsake-for-hospice-and-after-pdf',
    gentle: 'gentle-word-searches-for-seniors-printable-edition-pdf'
  };
  function has(k) { return !!P[H[k]]; }

  // Only plain downloads get a quick Add to cart; personalized items need their product page.
  var QUICK = ['family', 'grandma', 'calm', 'dog', 'cat', 'anyPet', 'petGift', 'petKid', 'memory', 'gentle'];
  var MORE = [['Show me something else', 'start'], [DATA.text.ask_question, 'contact']];

  // Each node: text (string or function), products (keys), options [[label, node]], link [label, url], form 'contact' | 'news'
  var N = {
    start: {
      text: "Hi! I'm Little Bear's Helper. I can point you to the right gift in about 30 seconds. Who are you shopping for?",
      options: [['A grandparent or older parent', 'grand'], ['A care home or activity room', 'care'], ['A party, shower or event', 'event'],
                ['A child', 'kids'], ['Remembering a pet', 'pet'], ['Remembering a person', 'person'], ['I have a question', 'faq']]
    },
    grand: {
      text: 'Lovely. What would they enjoy most?',
      options: [['Puzzles made from their own life', 'grandLife'], ['Telling their stories', 'grandStory'],
                ['Easy large print puzzles', 'grandPuzzles'], ['All of it, as one gift set', 'grandSet']]
    },
    grandLife: {
      text: 'This is our favorite gift. You tell us about them, and we build large print word searches from their life: their hometown, family names, the songs, the pets.',
      products: ['life', 'custom'], options: MORE, offerNews: true
    },
    grandStory: {
      text: function () {
        return has('story')
          ? 'Their Story sends them one gentle question a week. Their answers become a large print book the whole family keeps.'
          : 'Grandma, Tell Me Your Story is a printable keepsake journal: 100 gentle questions, each on its own page with room to write.';
      },
      products: ['story', 'grandma'], options: MORE, offerNews: true
    },
    grandPuzzles: {
      text: 'Big type (16-point or larger), easy grids, and themes they remember: Sunday dinner, the county fair, the old radio. Print at home as often as you like.',
      products: ['family', 'gentle'], options: MORE, offerNews: true
    },
    grandSet: {
      text: 'The Grandparent Gift Set puts it together: their personalized puzzle book, five printable books, and a book given to a care home in their name.',
      products: ['grandSet'], options: MORE, offerNews: true
    },
    care: {
      text: 'Thank you for what you do. How do you like to run activity hour?',
      options: [['I print my own copies', 'carePrint'], ['Send us printed books', 'careBooks'], ['Give a book to a community', 'careGive'], [DATA.text.bulk_question, 'contactBulk']]
    },
    carePrint: {
      text: function () {
        return has('license')
          ? 'The Activity Director Print License lets your community copy every page of six large print books for a full year: 400+ puzzles, with answer keys.'
          : 'The Family Bundle gives you five large print printable books. Ask Les about a yearly print license for your whole community.';
      },
      products: ['license', 'family'], options: [[DATA.text.bulk_question, 'contactBulk'], ['Show me something else', 'start']]
    },
    careBooks: {
      text: DATA.text.care_books,
      products: ['pack'], options: [[DATA.text.bulk_question, 'contactBulk'], ['Show me something else', 'start']]
    },
    careGive: {
      text: 'Give a Book in Their Name sends a large print puzzle book to a care home, in honor of someone you love.',
      products: ['give'], options: MORE
    },
    event: {
      text: "We'll make a word search from your words: names, places, inside jokes. Great for showers, birthdays, reunions and retirements. A real person builds it and checks every word.",
      products: ['custom'], options: [['How does it work?', 'faqCustom'], ['Show me something else', 'start']], offerNews: true
    },
    kids: {
      text: 'Fun! What sounds right?',
      options: [['A storybook starring them', 'kidsBook'], ['Calm-down activities', 'kidsCalm'], ['A big gift set', 'kidsSet']]
    },
    kidsBook: { text: 'Their own picture book, with them as the star of a big day in Bearberry Hollow.', products: ['kidsBook'], options: MORE, offerNews: true },
    kidsCalm: {
      text: "Little Bear's Calm Corner: mazes, feelings word searches and calm-down coloring for kids ages 6 to 12 with busy brains and big feelings.",
      products: ['calm'], options: MORE, offerNews: true
    },
    kidsSet: { text: 'Their own storybook, a birthday word search, and the whole Calm Corner, in one gift.', products: ['kidsSet'], options: MORE, offerNews: true },
    pet: {
      text: "I'm so sorry. Who are you remembering?",
      options: [['A dog', 'petDog'], ['A cat', 'petCat'], ['Another pet', 'petOther'], ['A gift for a grieving friend', 'petGift'], ['Helping a child say goodbye', 'petKid']]
    },
    petDog: { text: 'Little Bear was our own good dog for more than sixteen years. We made these for the days after.', products: ['dog', 'anyPet'], options: MORE },
    petCat: { text: 'Written for cats specifically: their dignity, their chosen people, their strong opinions about furniture.', products: ['cat', 'anyPet'], options: MORE },
    petOther: { text: 'Our complete memorial bundle works for any pet who was family.', products: ['anyPet'], options: MORE },
    petGift: { text: 'Something real to send instead of wondering what to say.', products: ['petGift'], options: MORE },
    petKid: { text: 'A gentle kit to help a child understand, remember and say goodbye.', products: ['petKid'], options: MORE },
    person: {
      text: "I'm sorry. In Loving Memory is a printable keepsake a family can fill in together, in the hardest weeks or after. Their Story is for keeping a loved one's stories while you still can.",
      products: ['memory', 'story'], options: MORE
    },
    faq: {
      text: 'Ask away. Here are the common ones:',
      options: [['How do downloads work?', 'faqDl'], ['How long do personalized orders take?', 'faqTime'], ['How big is the large print?', 'faqLp'],
                ['Are your books on Amazon?', 'faqBooks'], ['Shipping and refunds', 'faqPolicy'], [DATA.text.send_message, 'contact']]
    },
    faqDl: {
      text: DATA.text.download_help,
      link: ['How digital downloads work', '/pages/how-digital-downloads-work'], options: [['Another question', 'faq'], ['Find a gift', 'start']]
    },
    faqTime: {
      text: DATA.text.personalized_timing,
      options: [['Another question', 'faq'], ['Find a gift', 'start']]
    },
    faqCustom: {
      text: DATA.text.custom_steps,
      products: ['custom'], options: [['Another question', 'faq'], ['Find a gift', 'start']]
    },
    faqLp: { text: 'Our large print pages use 16-point type or bigger, with easy grids and lots of white space.', options: [['Another question', 'faq'], ['Find a gift', 'start']] },
    faqBooks: {
      text: 'Yes. The King Bear Squad mysteries and our large print puzzle books are on Amazon in paperback and hardcover.',
      link: ['See all the books', '/pages/books'], options: [['Another question', 'faq'], ['Find a gift', 'start']]
    },
    faqPolicy: {
      text: 'Downloads need no shipping. For printed items and refunds, here are the details:',
      links: [['Shipping policy', '/policies/shipping-policy'], ['Refund policy', '/policies/refund-policy']],
      options: [['Another question', 'faq'], [DATA.text.send_message, 'contact']]
    },
    contact: { text: DATA.text.contact_intro, form: 'contact', topic: 'Question' },
    contactBulk: { text: DATA.text.bulk_intro, form: 'contact', topic: 'Bulk or care-home pricing' }
  };

  // ---------- elements ----------
  var launch = document.getElementById('kbsh-launch');
  var panel = document.getElementById('kbsh-panel');
  var log = document.getElementById('kbsh-log');
  var ask = document.getElementById('kbsh-ask');
  var q = document.getElementById('kbsh-q');
  var teaser = document.getElementById('kbsh-teaser');
  var contactForm = document.getElementById('kbsh-contact');
  var newsForm = document.getElementById('kbsh-news');
  var started = false;

  function store(k, v) { try { if (v === undefined) return sessionStorage.getItem('kbsh-' + k); sessionStorage.setItem('kbsh-' + k, v); } catch (e) { return null; } }
  function track(action, label) {
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('kbs_helper', { action: action, label: label || '' }); } catch (e) {}
    try { if (window.fbq) window.fbq('trackCustom', 'KBSHelper', { action: action, label: label || '' }); } catch (e) {}
  }
  function el(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text) e.textContent = text; return e; }
  function scroll() { log.scrollTop = log.scrollHeight; }

  function say(text, who) { var b = el('div', 'kbsh-msg ' + (who === 'me' ? 'kbsh-me' : 'kbsh-bot'), text); log.appendChild(b); scroll(); return b; }

  function clearOptions() { var o = log.querySelectorAll('.kbsh-opts'); for (var i = 0; i < o.length; i++) o[i].parentNode.removeChild(o[i]); }

  function options(list) {
    var wrap = el('div', 'kbsh-opts');
    list.forEach(function (o) {
      var b = el('button', 'kbsh-opt', o[0]); b.type = 'button';
      b.addEventListener('click', function () { clearOptions(); say(o[0], 'me'); go(o[1]); });
      wrap.appendChild(b);
    });
    log.appendChild(wrap); scroll();
    var first = wrap.querySelector('button'); if (first && !panel.hidden) first.focus({ preventScroll: true });
  }

  function card(key) {
    var p = P[H[key]]; if (!p) return null;
    var c = el('div', 'kbsh-card');
    if (p.img) { var im = el('img'); im.src = p.img; im.alt = ''; im.loading = 'lazy'; im.width = 64; im.height = 64; c.appendChild(im); }
    var body = el('div', 'kbsh-card-body');
    body.appendChild(el('p', 'kbsh-card-t', p.t));
    body.appendChild(el('p', 'kbsh-card-p', (p.from ? 'From ' : '') + p.p));
    var row = el('div', 'kbsh-card-row');
    var a = el('a', 'kbsh-btn kbsh-btn-ghost', 'See it'); a.href = p.u;
    a.addEventListener('click', function () { track('view_product', H[key]); });
    row.appendChild(a);
    if (p.single && p.v && QUICK.indexOf(key) > -1) {
      var add = el('button', 'kbsh-btn', 'Add to cart'); add.type = 'button';
      add.addEventListener('click', function () { addToCart(p, add, H[key]); });
      row.appendChild(add);
    }
    body.appendChild(row); c.appendChild(body);
    return c;
  }

  function addToCart(p, btn, handle) {
    btn.disabled = true; btn.textContent = 'Adding...';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: p.v, quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function () {
        btn.textContent = 'Added';
        track('add_to_cart', handle);
        var m = say('Added to your cart. ', 'bot');
        var a = el('a', 'kbsh-link', 'Go to checkout'); a.href = '/cart'; m.appendChild(a);
        try { document.dispatchEvent(new CustomEvent('cart:refresh')); } catch (e) {}
      })
      .catch(function () { btn.disabled = false; btn.textContent = 'Add to cart'; say("That didn't go through. Try the See it button instead.", 'bot'); });
  }

  function showForm(kind, topic, prefill) {
    var f = kind === 'news' ? newsForm : contactForm; if (!f) return;
    var old = f.parentNode; if (old && old.classList && old.classList.contains('kbsh-formwrap')) old.parentNode.removeChild(old);
    var holder = el('div', 'kbsh-formwrap');
    holder.appendChild(f); f.hidden = false;
    if (kind === 'contact') {
      var t = f.querySelector('[data-kbsh-topic]'); if (t) t.value = topic || 'Question';
      var b = f.querySelector('[data-kbsh-body]'); if (b && prefill) b.value = prefill;
    }
    log.appendChild(holder); scroll();
    store('pending', kind);
    track('form_open', kind);
  }

  function offerNews() {
    if (!newsForm || store('news') === '1') return;
    var m = say('Want new puzzles, and the next King Bear Squad case, first? ', 'bot');
    var b = el('button', 'kbsh-linkbtn', 'Join the email list'); b.type = 'button';
    b.addEventListener('click', function () { b.disabled = true; showForm('news'); });
    m.appendChild(b);
  }

  function go(id, prefill) {
    var n = N[id] || N.start;
    track('step', id);
    var text = typeof n.text === 'function' ? n.text() : n.text;
    say(text, 'bot');
    if (n.products) {
      var shown = 0, list = el('div', 'kbsh-cards');
      n.products.forEach(function (k) { var c = card(k); if (c) { list.appendChild(c); shown++; } });
      if (shown) { log.appendChild(list); scroll(); }
    }
    var links = n.links || (n.link ? [n.link] : []);
    links.forEach(function (l) { var m = say('', 'bot'); var a = el('a', 'kbsh-link', l[0]); a.href = l[1]; m.appendChild(a); });
    if (n.form) showForm(n.form, n.topic, prefill);
    if (n.offerNews) offerNews();
    if (n.options) options(n.options);
  }

  // ---------- free text ----------
  var RULES = [
    [/refund|return|money back/, 'faqPolicy'], [/\bship|shipping|deliver|arriv/, 'faqPolicy'],
    [/download|pdf|print(ed|ing)? at home|file/, 'faqDl'],
    [/how long|when will|turnaround|how fast|ready/, 'faqTime'],
    [/amazon|kindle|paperback|hardcover|mystery|novel|series/, 'faqBooks'],
    [/large print|font|type size|how big|eyesight|vision/, 'faqLp'],
    [/bulk|license|discount for|nonprofit|church|order (\d+|many)/, 'contactBulk'],
    [/\bkids?\b|child|\bson\b|daughter|grandson|granddaughter|adhd|calm|anxi/, 'kids'],
    [/nursing|care home|assisted|activit|facility|resident|memory care|senior center|adult day/, 'care'],
    [/dog|puppy|cat\b|cats|kitten|pet\b|pets|horse|rabbit|bunny|guinea/, 'pet'],
    [/passed|died|memorial|funeral|grief|loss|hospice|sympathy/, 'person'],
    [/dementia|alzheimer/, 'grandPuzzles'],
    [/shower|wedding|bridal|baby|party|reunion|retire|anniversar|event|custom/, 'event'],
    [/grand|mom|mother|dad|father|parent|elderly|senior|aging|older/, 'grand'],
    [/story|stories|journal|memoir|questions/, 'grandStory'],
    [/puzzle|word search|sudoku|maze|coloring/, 'grandPuzzles'],
    [/gift|present|idea|recommend|suggest|shop/, 'start'],
    [/human|person|\bles\b|talk|call|email|contact|help/, 'contact']
  ];
  ask.addEventListener('submit', function (e) {
    e.preventDefault();
    var text = (q.value || '').trim(); if (!text) return;
    q.value = ''; clearOptions(); say(text, 'me'); track('typed', text.slice(0, 80));
    var low = text.toLowerCase(), target = null;
    for (var i = 0; i < RULES.length; i++) { if (RULES[i][0].test(low)) { target = RULES[i][1]; break; } }
    if (target === 'contact' || !target) {
      if (!target) say(DATA.text.fallback, 'bot');
      go('contact', text);
      options([['Find a gift instead', 'start']]);
    } else { go(target); }
  });

  // ---------- open / close ----------
  function open(src) {
    panel.hidden = false; launch.setAttribute('aria-expanded', 'true'); root.classList.add('kbsh-open');
    hideTeaser(true); track('open', src || 'button');
    if (!started) { started = true; go('start'); }
    else { var b = log.querySelector('.kbsh-opts button'); (b || q).focus({ preventScroll: true }); }
    store('open', '1');
  }
  function close() { panel.hidden = true; launch.setAttribute('aria-expanded', 'false'); root.classList.remove('kbsh-open'); launch.focus(); store('open', '0'); }
  function hideTeaser(forever) { teaser.hidden = true; if (forever) store('teaser', 'done'); }

  launch.addEventListener('click', function () { panel.hidden ? open('button') : close(); });
  document.getElementById('kbsh-close').addEventListener('click', close);
  document.getElementById('kbsh-teaser-go').addEventListener('click', function () { open('teaser'); });
  document.getElementById('kbsh-teaser-x').addEventListener('click', function () { hideTeaser(true); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !panel.hidden) close(); });

  // ---------- after a form post (page reloads) ----------
  var params = new URLSearchParams(location.search);
  var contactOk = params.get('contact_posted') === 'true' || !!document.querySelector('[data-kbsh-contact-ok]');
  var newsOk = params.get('customer_posted') === 'true' || !!document.querySelector('[data-kbsh-news-ok]');
  var pending = store('pending');
  root.hidden = false;
  if (pending && (contactOk || newsOk)) {
    store('pending', '');
    started = true; open('return');
    if (pending === 'news' && newsOk) { store('news', '1'); say("You're on the list. Thank you! Watch your inbox for new puzzles.", 'bot'); track('news_joined'); }
    else if (pending === 'contact' && contactOk) { say(DATA.text.contact_success, 'bot'); track('contact_sent'); }
    options([['Find a gift', 'start'], ['I have a question', 'faq']]);
  } else if (pending && document.querySelector('[data-kbsh-contact-err]')) {
    store('pending', ''); started = true; open('return');
    say("Something was missing from the form. Please check your email address and try again.", 'bot');
    go('contact');
  }

  // ---------- gentle teaser ----------
  var type = DATA.pageType || '';
  if (store('teaser') !== 'done' && type !== 'cart' && type !== 'captcha' && type !== 'password') {
    setTimeout(function () { if (panel.hidden && store('teaser') !== 'done') { teaser.hidden = false; track('teaser_shown'); } }, 12000);
  }
})();
